module.exports = "<span *ngIf=\"counter\" class=\"badge badge-pill badge-danger float-right mr-1 mt-1\">\n    {{counter}}\n</span>"